import { observer } from "mobx-react-lite";

import ChooseEntityDialog from "@/components/ChooseEntityDialog";
import { Entity, EntityType } from "@/queries";

interface SelectDatasetProps {
  dataset?: Entity<EntityType.DATASET>;
  onSelect: (dataset: Entity<EntityType.DATASET>) => void;
  sourceDatasetId?: number | null;
  disabled?: boolean;
  readonly?: boolean;
  isLoading?: boolean;
  onCreateNew?: () => void;
  onEditDataset?: () => void;
  url?: string;
  className?: string;
  selectLatest?: boolean;
}

function SelectDataset({
  dataset,
  onSelect,
  sourceDatasetId = null,
  disabled = false,
  readonly,
  isLoading = false,
  onCreateNew,
  onEditDataset,
  url,
  className,
  selectLatest = false,
}: SelectDatasetProps) {
  const selectedEntity: Entity | undefined = dataset;

  const isReadonlyState = readonly ?? disabled;

  return (
    <ChooseEntityDialog
      type={EntityType.DATASET}
      onSelect={onSelect as (dataset: Entity) => void}
      selectedEntity={selectedEntity}
      config={{
        selectLatest,
      }}
      className={className}
      disabled={
        sourceDatasetId
          ? [
              {
                id: sourceDatasetId,
                type: EntityType.DATASET,
              } as Entity,
            ]
          : undefined
      }
      currentFolderId={dataset?.folder_id ?? null}
      readonly={isReadonlyState}
      isLoading={isLoading}
      onInlineCreate={onCreateNew}
      onInlineEdit={onEditDataset}
      url={url}
    />
  );
}

export default observer(SelectDataset);
